import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './counterTop.module.scss';
export default class CounterTop extends React.Component<any, any> {

    ArrayToTable = (mainArray: any) => {
        // Extract unique keys from all objects
        const keys = [...new Set(mainArray.flatMap(obj => Object.keys(obj)))];

        return (
            <div style={{ fontSize: '9px' }}>
                <table style={{ borderCollapse: "collapse" }}>
                    <tbody>
                        {keys.map((key: any) => (
                            <tr key={key}>
                                <td style={{ border: "1px solid #ddd", padding: "2px", width: "120px" }}>{key === 'Annotation' ? 'Table' : key}</td>
                                {mainArray.map((obj, index) => (
                                    <td key={`${key}-${index}`} style={{ border: "1px solid #ddd", padding: "2px", width: "120px" }}>
                                        {obj[key] ? obj[key] : "N/A"}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { elevationImage, tables } = pageDetails;

        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}` : defaultImage} alt="" className="image-view" />
                    </div>
                </div>

                <div className="details-tables" >
                    <div className="details" style={{ marginTop: "5px" }}>
                        <>
                            {/* {   
                                tables && tables["COUNTERTOP"] && tables["COUNTERTOP"].length ? tables["COUNTERTOP"].map((table,index) => {
                                    return (table && Object.keys(table).length ? <div className="details-table" style={{minWidth:"26%"}}>
                                        <>  <div className="table-heading">
                                                {table?.Annotation || `COUNTERTOP-${index+1}`}
                                            </div>
                                            {Object.entries(table).map(([key, value]) => {
                                                if(key==="Annotation") return null;
                                                return (
                                                    <div className="table-row">
                                                        <div className="table-cell color-heading">{key}</div>
                                                        <div className="table-cell">{value ? value : "NA"}</div>
                                                    </div>
                                                )
                                                
                                            })
                                            }
                                        </>
                                    </div> : null
                                    )
                                }) : ""
                            } */}

                            {
                                tables && tables["COUNTERTOP"] && tables["COUNTERTOP"]?.length ? <div className="ct_table">{this.ArrayToTable(tables["COUNTERTOP"])} </div> : ""
                            }
                            {/* <table style={{ borderCollapse: "collapse", marginLeft: "5px", fontSize: '9px' }}>
                                <tbody>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "2px", width: "150px" }} className={`${styles.center}`}>CT01</td>
                                        <td style={{ border: "1px solid #ddd", padding: "2px", width: "150px" }} className={`${styles.center}`}>CT02</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "2px", width: "150px" }} className={`${styles.lineImage} ${styles.center}`}><img src={defaultImage} style={{ width: "100%" }} /></td>
                                        <td style={{ border: "1px solid #ddd", padding: "2px", width: "150px" }} className={`${styles.lineImage} ${styles.center}`}><img src={defaultImage} style={{ width: "100%" }} /></td>
                                    </tr>
                                </tbody>
                            </table> */}
                            <div className="details-table" style={{ marginTop: "0px", marginRight: "0px", width: '28%' }}>
                                <table style={{ borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }}>JOINT IN GRANITE SLAB</td>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }} className={`${styles.lineImage} ${styles.center}`}>--------</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }}>NOSING</td>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }} className={`${styles.waveImage} ${styles.center}`}>&#8767;&#8767;&#8767;&#8767;&#8767;&#8767;&#8767;</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }}>BACKSPLASH</td>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px", color: "#00FF00" }} className={`${styles.waveImage} ${styles.center}`}>&#8767;&#8767;&#8767;&#8767;&#8767;&#8767;&#8767;</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }}>STRUCTURAL ENTITY AREA</td>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }} className={`${styles.waveImage} ${styles.center} ${styles.triangleWave}`}>NNNNNNNNN</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }}>Vertical Countertop</td>
                                            <td style={{ border: "1px solid #ddd", padding: "2px", width: "300px" }} className={`${styles.lineImage} ${styles.center} ${styles.straightLine}`}>---------------</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </>
                    </div>
                </div>
            </React.Fragment>

        )
    }

}